import CheatModeTemplateCreate from './cheat-mode-template.create';
import CheatModeTemplateEdit from './cheat-mode-template.edit';

export default {
  create: CheatModeTemplateCreate,
  edit: CheatModeTemplateEdit,
};
